import { axiosClient } from '@nx-frontend/shared/api';
import { Workspace } from '@nx-frontend/shared/types';
import { WorkspaceAvatar } from '@nx-frontend/shared/types';

export async function clientGetOrgWorkspaces({
  orgId,
}: {
  orgId: string;
}): Promise<(Workspace & { avatarStoredFileUUID?: string })[] | null> {
  try {
    const response = await axiosClient.get<{ workspaces: Workspace[] }>(`/v2/api/orgs/${orgId}/workspaces`);
    if (response.data.workspaces && response.data.workspaces.length) {
      const workspaces = response.data.workspaces;
      const avatarsResponses = await Promise.all(
        workspaces.map((workspace) =>
          axiosClient.get<{ avatar: WorkspaceAvatar }>(`/v2/api/workspaces/${workspace.globalId}/avatar`)
        )
      );
      return workspaces.map((workspace, index) => {
        if (avatarsResponses[index] && avatarsResponses[index].data.avatar) {
          return Object.assign({}, workspace, {
            avatarStoredFileUUID: avatarsResponses[index].data.avatar.storedFileUUID,
          });
        }
        return workspace;
      });
    }
    return [];
  } catch (err) {
    console.log(`getOrgWorkspaces error: ${err}`);
  }
  return null;
}
